export const environment = {
  production: false,
  version: '1.0.11',
  local: false,
  development: true,
  apiUrl:
    'https://svt-pre-api.mangoisland-0038c8a6.westeurope.azurecontainerapps.io',
  emojiApiKey: '0efae4588e7bf06b309e49789783889b4b669faa',
  azure: {
    auth: {
      scopes: ['api://5039f502-a87e-4d6d-91b5-65445188e2a1/access_as_user'],
      logoutRedirect: 'http://localhost:4200/login',
    },
  },
};

//api://5039f502-a87e-4d6d-91b5-65445188e2a1/access_as_user //serveto
//api://2638a360-1a47-442d-9a38-96ebff06c327/access_as_user //useit
